import styled from 'styled-components'
import { Button } from 'reactstrap'

export const CookieBannerWrapper = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    min-height: 50px;
    background-color: #F4F3F4;
    padding: 25px;
    z-index: 5000;
`

export const CookieBannerHeadline = styled.div`
    font-weight: bold;
    font-size: 1.1rem;
    margin-bottom: 10px;
`

export const CookieBannerTextWrapper = styled.div`
    font-size: 1rem;
`

export const CookieBannerButtonsWrapper = styled.div`
    margin-top: 20px;
    text-align: right;
`

export const CookieBannerAcceptButton = styled(Button)`
    margin-left: 30px;
    width: 100px;
`

export const CookieBannerDeclineButton = styled.div`
    font-size: 0.8rem;
    font-weight: 300;
    display: inline-block;
`



// WEBPACK FOOTER //
// ./src/components/StyledComponents/Global/CookieBanner.js